"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UILayer = void 0;
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const GameState_1 = require("../../Core/GameState");
const GameConfig_1 = require("../../Core/GameConfig");
const InfoSprite_1 = require("../../Common/InfoObject/InfoSprite");
const SymbolClasses_1 = require("../../Utils/SymbolClasses");
const InfoNumberSprite_1 = require("../../Common/InfoObject/InfoNumberSprite");
let UILayer = class UILayer extends pixi_js_1.Container {
    constructor(state, config, resources, events) {
        super();
        const info = resources.ui.data.info.game;
        const textures = resources.ui.textures;
        if (info.other instanceof Array) {
            for (const x of info.other) {
                this.addChild(new InfoSprite_1.InfoSprite(x, textures));
            }
        }
        const judge = new InfoSprite_1.InfoSprite(info.judge, textures);
        const pause = new InfoSprite_1.InfoSprite(info.pause, textures);
        const combo = new InfoNumberSprite_1.InfoNumberSprite(info.combo, textures);
        const score = new InfoNumberSprite_1.InfoNumberSprite(info.score, textures);
        // if (!config.autoplay)
        this.addChild(judge);
        this.addChild(pause);
        this.addChild(combo);
        this.addChild(score);
        pause.interactive = true;
        //        pause.buttonMode = true
        pause.on("pointertap", () => {
            if (!state.paused)
                state.on.pause.emit();
        });
        score.setValue(0);
        combo.visible = false;
        state.on.judge.add((remove, note) => {
            if (!this.parent)
                return remove();
            judge.texture = textures[note.judge];
            judge.resetAnim();
            if (state.currentCombo > 0) {
                combo.setValue(state.currentCombo);
                combo.resetAnim();
                combo.visible = true;
            }
            else {
                combo.visible = false;
            }
            score.setValue(state.score);
            score.resetAnim();
        });
        events.Update.add((remove, dt) => {
            if (!this.parent)
                return remove();
            if (state.paused)
                return;
            for (const x of this.children) {
                if (x instanceof InfoSprite_1.InfoSprite || x instanceof InfoNumberSprite_1.InfoNumberSprite) {
                    x.update(dt);
                }
            }
        });
    }
};
UILayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [GameState_1.GameState, GameConfig_1.GameConfig, SymbolClasses_1.Resources, SymbolClasses_1.GlobalEvents])
], UILayer);
exports.UILayer = UILayer;
//# sourceMappingURL=UILayer.js.map